/* Popup style */
import styled, { css } from "styled-components";
import {Modal} from "react-bootstrap";

const PopupBox = styled.div`
  position: fixed;
  background: #00000050;
  width: 100%;
  height: 100vh;
  left: 0;
`;

const Box = styled.div`
  position: relative;
  width: 550px;
  margin: 0 auto;
  ${"" /* height: 693px; */}
  max-height: 70vh;
  margin-top: calc(100vh - 85vh - 20px);
  background: #fff;
  border-radius: 10px;
  border: 1px solid #999;
  overflow: hidden;
`;

const Heading = styled.div`
  ${"" /* position: fixed; */}
  background: linear-gradient(180deg, #52A8ED 0%, #8AD3F7 100%);
  border-radius: 6px 6px 0px 0px;

  width: 100%;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: auto;
  font-family: Rubik;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
  display: block;

  color: #ffffff;

  p {
    font-family: Rubik-Medium;
    font-size: 18px;
    line-height: 24px;
    color: #ffffff;
    margin: 0px;
font-size: 18px;
line-height: 24px;
color: #FFFFFF;
text-align: center;
padding: 20px 0px;
  }
  >div{
    position:relative;
    bottom: 20%;
    height:0px;
    display: flex;
    justify-content: flex-end;
    right: 15px;
    bottom: 50px;
      >img{
          cursor: pointer;
      }
  }
`;

const Title = styled.div`
  background: #fd7175;
  width: 100%;
  height: 85px;
  margin-top: 14px;
  text-align: left;
  font-family: Rubik;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 20px;
  text-transform: uppercase;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: left;

  flex-direction: column;

  h4 {
    text-align: left;
    font-family: Rubik-Medium;
    font-size: 18px;
    line-height: 24px;
    color: #ffffff;
    padding: 0px 15px;
    padding: 0px 15px;
font-size: 18px;
line-height: 20px;
text-transform: uppercase;
color: #FFFFFF;
margin-top: 20px;
  }
  p {
    text-align: left;
    font-family: Rubik;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
    color: #ffffff;
    padding: 0px 15px;

    font-family: Rubik;
font-style: normal;
font-weight: normal;
font-size: 14px;
line-height: 24px;
text-transform: uppercase;
color: #FFFFFF;
margin-bottom: 15px;
  }
`;

const Quetion = styled.div`
  box-sizing: border-box;
  padding: 30px;
  margin: 35px 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(248, 168, 135, 0.19);
  border-radius: 6px;
  height: 185px;
  width: 100%;
  flex-direction: column;
  p {
    height: 48px;
    font-family: Rubik;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: #0D4270;

    font-family: Rubik;
font-style: normal;
font-weight: normal;
font-size: 16px;
line-height: 24px;
text-align: center;
color: #0D4270;
  }
  h5 {
    text-align: center;
    position: relative;
    bottom: 45px;
    background: #ffffff;
    color: red;
    width: 68px;
    border-radius: 31px;
    font-size: 16px;
    padding: 7px 0px;
  }

  h4 {
    text-align: center;
    position: relative;
    bottom: -50px;
    background: #ffffff;
    color: red;
    width: 50px;
    border-radius: 50%;
    background: #FFFFFF;
border-radius: 15.7745px;
width: 32px;
font-size: 16px;
padding: 7px 0px;
  }
`;

const Answer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  width: 560px;
  border: 2px solid #9c9c9c;
  border-radius: 6px;
  margin: 10px auto;
  font-family: Rubik;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: #0D4270;
  padding: 10px;
  background: ${({ checked }) => checked ? '#FD7175' : 'transparent'};
  >p{
    font-family: Rubik;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: ${({ checked }) => checked ? '#FFF' : '#0D4270'};
    margin:0px;
    &:hover, &:active, &:focus {
      color: white;
    }
  }
  &:hover, &:active, &:focus {
    background: #FD7175;
    box-shadow: 0px 4px 3px rgba(253, 113, 117, 0.35);
    border-radius: 6px;
    color: white;
    padding: 12px 10px;
    width: 560px;
    margin: 10px auto;
    border: none;
    >p{
      color: white;
      font-family: Rubik;
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 24px;
      text-align: center;
    }
  }
`;

const ButtonPrev = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 10px 20px 10px 20px;
  float: left;
  width: 140px;
  height: 50px;
  padding: auto;
  background: #0D4270;
  font-weight: 500;
  border-radius: 6px;
  font-family: Rubik-Medium;
  p {
    font-family: Rubik-Medium;
    font-size: 18px;
    line-height: 24px;
    color: white;
    margin: 0px;
  }
`;

const ButtonNext = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 15px;
  font-weight: 500;
  margin: 10px 20px 10px 20px;

  float: right;
  width: 140px;
  height: 50px;
  padding: auto;
  background: #0D4270;
  border-radius: 6px;
  font-family: Rubik-Medium;
  ${({ disabled }) => disabled === true && css`
    opacity: 0.5;
    cursor: not-allowed !important;
  `}
  p {
    font-family: Rubik-Medium;
    font-size: 18px;
    line-height: 24px;
    color: white;
    margin: 0px;
  }
`;

const ButtonSubmit = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 15px;
  font-weight: 500;
  margin: 10px 20px 10px 20px;
  float: right;
  width: 140px;
  height: 50px;
  padding: auto;
  background: #0D4270;
  border-radius: 6px;
  color: white;
  font-family: Rubik-Medium;
  font-size: 18px;

  p {
    font-family: Rubik;
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 24px;
    color: white;
    margin: 0px;
  }
  ${({ disabled }) => disabled === true && css`
  opacity: 0.5;
  cursor: not-allowed !important;
`}
`;

const Upper = styled.div`
  background: #E7EEF8;
  border-radius: 6px 6px 0px 0px;
  height: 550px;
  padding-top: 32px;

  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  justify-content: flex-start;

  p {
    text-align: center;
    color: white;
  }

  h1 {
    font-size: 24px;
    color: white;
    text-align: center;
  }
  .one{
    color: #184A61;
text-align: center;
font-family: Lato;
font-size: 18px;
font-style: normal;
font-weight: 700;
line-height: 24px;

margin: 0px;
margin-bottom: 15px;
  }
  .two{
    color: #184A61;
text-align: center;
font-family: Lato;
font-size: 32px;
font-style: normal;
font-weight: 700;
line-height: 38px;

    margin: 0px;
margin-bottom: 20px;
  }
  .three{
    color: #184A61;
font-family: Lato;
font-size: 18px;
font-style: normal;
font-weight: 400;
line-height: 24px;

margin: 0px;
  }
  .four{
    color: #184A61;
text-align: center;
font-family: Lato;
font-size: 18px;
font-style: normal;
font-weight: 700;
line-height: 24px;
margin:20px 0px;
  }
`;

const Lower = styled.div`
  background: #F8F8F8;
  border-radius: 6px;
  ${'' /* height: 246px; */}
  ${"" /* position: relative; */}
`;

const Card = styled.div`
  width: 678px;
  background: #ffffff;
  ${'' /* box-shadow: 0px 4px 9px rgba(0, 0, 0, 0.13); */}
  border-radius: 12px;
  margin: 0px auto;
  position: relative;
  top: -100px;
  display: flex;
  flex-wrap: wrap;
  padding:20px 40px;
  .outer {
    width: 50%;
    display: flex;
    ${'' /* padding: 10px 20px; */}
    ${'' /* padding-bottom:60px; */}
>img{
  height: 48px;
  width: auto;
}
    > p {
      font-family: Rubik;
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 16px;
      color: green;
      margin-right: 20px;
      float: right;
      padding: 10px;
      vertical-align: top;
    }
    .inner {
      padding-top: 0px;
      display:flex;
      justify-content:space-around;
      flex-direction:column;
      margin-left:20px;
      .text{
        color:#184A61;
font-family: Lato;
font-size: 18px;
font-style: normal;
font-weight: 700;
line-height: 24px;
      }
      p {

        color: #184A61;
font-family: Lato;
font-size: 32px;
font-style: normal;
font-weight: 700;
line-height: 38px; 
        margin: 0px;
        margin-top: 5px;
      }
      span{
font-family: Rubik;
font-style: normal;
font-weight: normal;
font-size: 16px;
line-height: 16px;
color: #0D4270;
      }
    }
  }
`;

const ButtonPlay = styled.button`
  width: 47%;
  width: ${({ width }) => width ? '100%' : '47%'};
  height: 50px;
  background: #fd7175;
  float: right;
  border: none;
  color: white;
  font-size: 20px;
  font-family: rubik-medium;
font-size: 18px;
line-height: 24px;
text-align: center;

color: #FFFFFF;
border-radius: 6px;
`;

const ButtonClose = styled.button`
  width: 45%;
  width: ${({ width }) => width ? '100%' : '47%'};
  height: 50px;
  background: white;
  float: left;
  border: 1px solid #3a3a3a;
  font-size: 20px;
  font-family: rubik-medium;
  font-size: 18px;
  line-height: 24px;
  text-align: center;
  color: #9C9C9C;
  border: 1px solid #9C9C9C;
  border-radius: 6px;
`;

const CircleNew = styled.div`
  width: 260px;
  height: 200px;
  border-radius: 50%;
  ${'' /* background: red; */}
  ${'' /* background: rgba(138, 211, 247, 0.36); */}
${'' /* box-shadow: 0px 18px 20px rgba(0, 0, 0, 0.02); */}
padding: 10px;
display: flex;
justify-content: center;
align-items: center;
`;

const Circles = styled.div`
  width: 240px;
  height: 240px;
  border-radius: 50%;
  border: 7px solid #92A4DA;
  margin: 0px auto;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  p {
    font-size: 80px;
    font-weight: 900px;
    color: #0D4270;
  }
  h1 {
    margin-top: -10px;
    color: #ffffff;
    font-size: 24px;
  }
`;

const ButtonWrapper = styled.div`

display:flex; 
justify-content:space-between;
justify-content: ${({ display }) => display ? 'space-between' : 'flex-end'};
`;

const ButtonWrapperNew = styled.div`

display:flex; 
justify-content:space-between;
justify-content: ${({ display }) => display ? 'center' : 'space-between'};
padding: 0px 25px;
position:relative;
bottom:50px;
`;

const ModalStyled = styled(Modal)`
  .modal-dialog {
    .modal-header {
    }
    @media (max-width: 500px){
      width: 100%;
      padding: 10px;
      margin: 0px;
    }
  }
  .modal-content{
    width:600px;
    @media (max-width: 500px){
      width: 100%;
    }
  }
  @media (max-width: 500px){
    padding: 0px;
  }
`;

const StyledModal = styled(Modal)`
@media (min-width: 576px){
  .modal-dialog {
    max-width:100% !important;
  }}
  .modal-dialog {
    width: ${({width}) => width ? width : '485px'};
    border-radius: 8px;
    background: linear-gradient(180deg, #FFFFFF 0%,rgba(255,255,255,0) 100%), #FFFFFF;
    ${'' /* box-shadow: 0px 4px 4px rgb( / 25%); */}
    transform: translate(0, 50vh) translate(0, -50%);
    margin: 80px auto;
    border: none;
    top:-65px;
    @media (min-width: 576px){
      .modal-dialog {
        max-width:100% !important;
      }}
    .modal-content {
      height: 100%;
      height:${({height}) => height?height :'100%'};
      width:100%;
      border: none;
      background-color: ${({bgcolor, background}) => background?background: (bgcolor || !bgcolor) ? 'transparent' : '#fff'};
    }
    .close {
      margin-top: -30px;
    }
    ${'' /* @media (max-height: 1200px) {
      width: 55%;
    } */}
    @media (max-height: 530px) {
      transform: none !important;
      margin: 30px auto;
    }
    @media (max-width: 766px) {
      width: 95%;
    }
  }
`;

const IconCircle = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  border: 1px solid var(--Bg-Color-for-Light-theme-300, #dcdcdc);
  background: var(--Bg-Color-for-Light-theme-500, #f8f8f8);
  display: flex;
  justify-content: center;
  align-items: center;
`;


export {
  Box,
  PopupBox,
  Title,
  Heading,
  Answer,
  Quetion,
  ButtonPrev,
  ButtonNext,
  ButtonSubmit, Upper, Lower, Card, ButtonPlay, ButtonClose, Circles, ButtonWrapper, CircleNew, ButtonWrapperNew, ModalStyled, StyledModal,IconCircle
};